import AsyncForm, { AsyncFormState } from './AsyncForm';
import { hasValue } from '../../lib/utils';

export default class PasswordForm<P, S extends PasswordFormState> extends AsyncForm<P, S> {
	handleValueChange = (name: string, value: string, errorMessage: string): void => {
		if (!hasValue(errorMessage)) {
			if (name === 'confirmPassword') {
				const confirmPasswordErrorMessage =
					value !== this.state.password
						? "Your password doesn't match the password confirmation, please re-enter."
						: null;
				// eslint-disable-next-line no-param-reassign
				errorMessage = confirmPasswordErrorMessage;
				this.setState({ confirmPasswordErrorMessage });
			}
		}

		super.handleValueChange(name, value, errorMessage);
	};
}

export interface PasswordFormState extends AsyncFormState {
	password: string;
	confirmPassword: string;
	confirmPasswordErrorMessage: string;
}
